// -------------------------------------------------------------------------------------------
// The goal of this file is to allow asynchronous importing of DevExpress components.
// If you import all classes directly in your components, DevExpress will be included in your bundle.
// But DevExpress components are huge (~600KB gzipped), so we want to load them asynchronously.
// -------------------------------------------------------------------------------------------
// HOW TO USE:
// 1. import DevExpress components ONLY from this file (never from '@devexpress' directly)
// 2. For components use `<DXRS.component_name />` (e.g. `<DXRS.Button />`), for instantiation use use `new DXRS.class_name()`

import type { ViewType } from 'devextreme/ui/scheduler';
import type {
  Appointments as AppointmentsBase,
  AppointmentModel,
  MonthView as MonthViewBase,
  ViewState,
} from '@devexpress/dx-react-scheduler';
import type {
  Appointments,
  MonthView,
  WeekView,
  Scheduler,
} from '@devexpress/dx-react-scheduler-material-ui';
export type {
  AppointmentsBase,
  AppointmentModel,
  MonthViewBase,
  ViewState,
  WeekView,
  ViewType,
  Scheduler,
};
let _promise: Promise<any> | null;
let _isLoaded: boolean;
let _error: any;

export let DXRS: {
  ViewState: typeof ViewState;
  Scheduler: typeof Scheduler;
  MonthView: typeof MonthView;
  Appointments: typeof Appointments;
  WeekView: typeof WeekView;
} = {} as any;
export function useDxReactScheduler() {
  if (!_isLoaded) {
    if (!_promise) {
      _promise = initScheduler();
    }
    // will trigger Suspense
    throw _promise;
  }
  if (_error) {
    throw _error;
  }
}

function initScheduler() {
  return Promise.all([
    import('@devexpress/dx-react-scheduler').then((x) => {
      DXRS = { ...DXRS, ViewState: x.ViewState };
    }),
    import('@devexpress/dx-react-scheduler-material-ui').then((x) => {
      DXRS = { ...DXRS, ...(x as any) };
    }),
  ])
    .finally(() => (_isLoaded = true))
    .catch((e) => (_error = e));
}
